import React from 'react'

import { Icon } from 'semantic-ui-react'
import { Typography, Button, Box, Card, CardContent } from '@mui/material'

import QRCode from 'qrcode.react'

import { IProject } from '../../../api/Data'

import ExternalLink from '../../../components/common/ExternalLink'

const InviteCard = (props: IProps) => {
  // Props
  const { project } = props
  
  const { slug, projectUrl, shared } = project

  const projectLinkForQRCode = `${projectUrl}?utm_source=qrcode` // utm is used to differentiate direct form qrcode scan

  const downloadQR = () => {
    const canvas: any = document.getElementById('qr-code')

    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')

    const downloadLink = document.createElement('a')

    downloadLink.href = pngUrl
    downloadLink.download = `${project.title.replace(/ /g, '-')}-qr-code.png`

    document.body.appendChild(downloadLink)

    downloadLink.click()

    document.body.removeChild(downloadLink)
  }
  
  return (
    <Card sx={{ width: '100%', boxSizing: 'border-box', height: '100%' }}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" fontWeight="bold">
            Invite Contributors
          </Typography>
          Project link<br/>
          {!shared && (
            <Typography variant="h6" fontWeight="bold">
              Project is Inactive
            </Typography>
          )}
          <div style={{ display: 'flex', gap: '0.25rem' }}>
            <ExternalLink url={projectUrl}>{projectUrl.split('//')[1]}</ExternalLink>
            <Icon name="copy" style={{ color: '#6b50ff', cursor: 'pointer' }} onClick={() => navigator.clipboard.writeText(projectUrl)} />
          </div>
          <Box display="flex" flexDirection="row" justifyContent="space-between" gap={2}>
            <Box>
              <Button variant="outlined" size="small" sx={{ margin: '10px 0', color: '#6b50ff', borderColor: '#6b50ff' }} href={`/projects/${slug}/collaborate`}>
                See Share Options
              </Button>
            </Box>
            <Box>
              <QRCode id="qr-code" value={projectLinkForQRCode} size={100} onClick={downloadQR} style={{ cursor: 'pointer' }} />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  project: IProject
}

export default InviteCard
